import {EventEmitter} from '@angular/core';

export class AuthenticationNotificationService {

    public event$: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor() {
        this.event$ = new EventEmitter();
    }

    public publish(item: boolean): void {
        if (!this.event$) {
            this.event$ = new EventEmitter<boolean>();
        }
        this.event$.emit(item);
    }
}
